import { render, staticRenderFns } from "./ReportesView.vue?vue&type=template&id=526e87e1&"
import script from "./ReportesView.vue?vue&type=script&lang=js&"
export * from "./ReportesView.vue?vue&type=script&lang=js&"
import style0 from "./ReportesView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports